"use strict";

import Axios from "axios";
import configuration from "../../configuration";

const url = configuration.apiHost + "convetion";

export default class ConventionService {

  static async getAll() {
    try {
      let convention = await Axios.get(url);
      return convention.data;
    } catch (error) {
      throw new Error(error);
    }
  } //getAll();

  static async save(convention) {
    try {
      let conventionSaved = await Axios.post(url, convention);
      return conventionSaved.data;
    } catch (error) {
      throw new Error(error);
    }
  } //save()

  static async edit(convention) {
    try {
      let resp = await Axios.put(url, convention);
      return resp.data
    } catch (error) {
      console.log(error)
      throw new Error(error);
    }
  } //edit()

  static async remove(convention) {
    try {
      await Axios.delete(url, {
        data: convention
      });
    } catch (error) {
      throw new Error(error);
    }
  } //remove()

  static async getByYear(convention) {
    try {
      let conventionGet = await Axios.post(url + "/ano", convention);
      return conventionGet.data;
    } catch (error) {
      throw new Error(error);
    }
  } //getByYear()

  static async getById(id) {
    try {
      let conventionGet = await Axios.get(`${url}/${id}`);
      return conventionGet.data;
    } catch (error) {
      throw new Error(error);
    }
  } //getById()

  static async getCurrentConvention() {
    try {
      let currentConvention = await Axios.get(url + "/current_convention");
      return currentConvention.data;
    } catch (error) {
      throw new Error(error);
    }
  } //getCurrentConvention()
} //class



// WEBPACK FOOTER //
// ./src/service/CollectiveConventionService.js